/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandColor} from '../api'

export const useMutationSetBrandColor = createReactQueryMutationHook('setBrandColor', setBrandColor)
